import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

// Minimal error boundary so a crash in one lazy route doesn't nuke the shell.
// Extend with Sentry / logging when that goes in.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught', error, info);
  }

  reset = () => this.setState({ error: null });

  render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="app-error" role="alert">
          <div>
            <strong>Something went sideways.</strong>
            <div style={{ marginTop: 8, fontFamily: 'monospace', fontSize: 12 }}>
              {this.state.error.message}
            </div>
            <button
              type="button"
              className="md-action md-action--primary"
              style={{ marginTop: 16 }}
              onClick={this.reset}
            >
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
